export const USER_ROLES = [
  { id: 'ROLE_CLIENT', name: 'klient' },
  { id: 'ROLE_SCOUT', name: 'partner' },
  { id: 'ROLE_FINANCIAL_ADVISOR', name: 'špecialista' },
  { id: 'ROLE_ADMIN', name: 'admin' },
];
